import { NotificationEventItem } from './NotificationEventItem'
import {
  AllApprovalsNotificationEventItem,
  PartialApprovalNotificationEventItem,
} from './common/approval'
import { CommentedNotificationEventItem } from './common/commented'
import { DispositionGivenNotificationEventItem } from './common/disposition'
import { EditedNotificationEventItem } from './common/edited'
import { NumberNameEditedNotificationEventItem } from './common/numberName'
import { RevertedNotificationEventItem } from './common/reverted'
import { NotificationEventEnum } from '.'
import { DSStatus } from '../statuses/ds'

const ds = 'Design Submittal' as const

const Submitted = new NotificationEventItem({
  id: '6dc112d8-8dd7-4a6a-9209-d89020d8d485',
  name: 'Submitted',
  description: `A new ${ds} is submitted for the workflow`,
})
const RoutedToDisciplineAction = new NotificationEventItem({
  id: 'cde56505-b32f-42d2-be19-cbcf342e3d66',
  name: 'Route to Discipline Action',
  description: `A router determines the ${ds} is ready for ${DSStatus.DisciplineAction.name}`,
})
const DisciplineReviewAccepted = PartialApprovalNotificationEventItem({
  id: '1345c77c-1cd6-4ba7-b9d4-f2f91e2fb467',
  name: 'Discipline Review Accepted',
  description: { object: ds, group: 'Discipline' },
})
const AllDisciplineReviewsAccepted = AllApprovalsNotificationEventItem({
  id: '2bd6aad6-a93e-4b3b-b363-b4167585c5ab',
  name: 'All Discipline Reviews Accepted',
  description: { object: ds, group: 'Discipline' },
})
const ReturnedToDesign = DispositionGivenNotificationEventItem({
  id: 'ee095888-c03b-4253-a023-443375eb830f',
  name: 'Returned to Design',
  submittal: ds,
})
const Reverted = RevertedNotificationEventItem({
  id: '308ddd1c-ae14-428e-a5b3-443bce057b31',
  revertable: ds,
  from: 'Returned to Design Builder',
  to: 'Discipline Action',
})
const NumberOrNameEdited = NumberNameEditedNotificationEventItem({
  id: '4850d8af-312d-4c65-ba8c-0388861552c8',
})
const Edited = EditedNotificationEventItem({
  id: '49de599c-e86f-4eca-b8c6-d8f75d437bf5',
  editable: ds,
})
const Commented = CommentedNotificationEventItem({
  id: 'bf5c91a6-c063-4fe2-84b5-9b88982edc42',
  commentable: ds,
})

export type DSNotificationEventItem =
  | typeof Submitted
  | typeof RoutedToDisciplineAction
  | typeof DisciplineReviewAccepted
  | typeof AllDisciplineReviewsAccepted
  | typeof ReturnedToDesign
  | typeof Reverted
  | typeof NumberOrNameEdited
  | typeof Edited
  | typeof Commented

class DSNotificationEventEnum extends NotificationEventEnum<
  'DSNotification',
  DSNotificationEventItem,
  DSNotificationEventItem['name'],
  DSNotificationEventItem['id']
> {
  readonly typename = 'DSNotification'
  get values() {
    return [
      this.Submitted,
      this.RoutedToDisciplineAction,
      this.DisciplineReviewAccepted,
      this.AllDisciplineReviewsAccepted,
      this.ReturnedToDesign,
      this.Reverted,
      this.NumberOrNameEdited,
      this.Edited,
      this.Commented,
    ]
  }
  readonly Submitted = Submitted
  readonly RoutedToDisciplineAction = RoutedToDisciplineAction
  readonly DisciplineReviewAccepted = DisciplineReviewAccepted
  readonly AllDisciplineReviewsAccepted = AllDisciplineReviewsAccepted
  readonly ReturnedToDesign = ReturnedToDesign
  readonly Reverted = Reverted
  readonly NumberOrNameEdited = NumberOrNameEdited
  readonly Edited = Edited
  readonly Commented = Commented
}

export const DSNotificationEvent = new DSNotificationEventEnum()
